//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useEffect, useState } from "react"
import { useParams   } from 'react-router';

// === API ===
import {on, removeListener, sendMessage, sendMessageData} from "api/prokey/prokey.websocket";

//#endregion

const ExpressionContext = createContext()

//-----------------------------------------------------------------
function ExpressionProvider( { children } ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { rule_id } = useParams();

  const [ rule , setRule ] = useState( {} );

  const [ id_expr     , setIdExpr      ] = useState( 0  );
  const [ id_pred     , setIdPred      ] = useState( 0  );
  const [ expressions , setExpressions ] = useState( [] );
  const [ predicates  , setPredicates  ] = useState( [] );
  
  const [ fields      , setFields      ] = useState( [] );
  const [ records     , setRecords     ] = useState( [] );
  const [ tables      , setTables      ] = useState( [] );
  const [ documents   , setDocuments   ] = useState( [] );
  const [ templates   , setTemplates   ] = useState( [] );
  const [ table_columns, setTableColumns ] = useState( {} );

  const [ is_saved , setIsSaved ] = useState( true );

  //#endregion

  //#region [EFFECT]
  
  useEffect( () => {
    //-----------------------------------------------------------------    
    function listener(data) {
      //-----------------------------------------------------------------
      setRule( data.rule || {} );
      initPredicates( data.rule.rule.PREDICATE?.values || [] );
      initExpression( data.rule.rule.RULE     ?.values || [] );
    }
    //-----------------------------------------------------------------    
    function listener2(data) {
      //-----------------------------------------------------------------
      const temp = data.fields.map( x=> {return {label: x, value: x} });
      setFields( temp );
    }
    //-----------------------------------------------------------------    
    function listener4(data) {
      //-----------------------------------------------------------------
      const temp = data.tables.map( x=> {return {label: x, value: x} });
      setTables( temp );
    }
    //-----------------------------------------------------------------    
    function listener3(data) {
      //-----------------------------------------------------------------
      const temp = data.documents;
      setDocuments( temp );
    }
    //-----------------------------------------------------------------    
    function listener5(data) {
      //-----------------------------------------------------------------
      const temp = data.records.map( x=> {return {label: x, value: x} });
      setRecords( temp );
    }
    //-----------------------------------------------------------------    
    function listener6(data) {
      //-----------------------------------------------------------------
      const temp = { ...table_columns };
      temp[data.table] = data.columns.map( x => { return {label: x, value: x} } );
      setTableColumns( temp );
    }
    //-----------------------------------------------------------------    
    function listener7(data) {
      //-----------------------------------------------------------------
      setTemplates( data.templates || [] );
    }

    on( 'ANALYTICS_RULE' , listener  );
    on( 'FIELD-LIST'     , listener2 );
    on( 'DOCUMENT-LIST'  , listener3 );
    on( 'TABLE-LIST'     , listener4 );
    on( 'RECORD-LIST'    , listener5 );
    on( 'TABLE-COLUMNS'  , listener6 );
    on( 'TEMPLATE-LIST'  , listener7 );
    
    const message  = JSON.stringify( { type: 'FIELD-LIST-REQUEST', data: { } } );
    sendMessage( message );
    
    const message4 = JSON.stringify( { type: 'TABLE-LIST-REQUEST', data: { } } );
    sendMessage( message4 );
    
    const message2 = JSON.stringify( { type: 'DOCUMENT-LIST-REQUEST', data: { tenant: '' } } );
    sendMessage( message2 );
    
    const message5 = JSON.stringify( { type: 'RECORD-LIST-REQUEST', data: { } } );
    sendMessage( message5 );
    
    const message7  = JSON.stringify( { type: 'TEMPLATE-LIST-REQUEST', data: { } } );
    sendMessage( message7 );

    sendMessageData( 'ANALYTICS_RULE_REQUEST', { id: rule_id } );

    return () => {
      removeListener( 'ANALYTICS_RULE' , listener  );
      removeListener( 'FIELD-LIST'     , listener2 );
      removeListener( 'TABLE-LIST'     , listener4 );
      removeListener( 'DOCUMENT-LIST'  , listener3 );
      removeListener( 'RECORD-LIST'    , listener5 );
      removeListener( 'TABLE-COLUMNS'  , listener6 );
      removeListener( 'TEMPLATE-LIST'  , listener7 );
    };
  }, [] ); // empty dependency = called only once at startup

  useEffect(() => {
    const listener = (event) => {
      if( is_saved ) return;
      event.preventDefault();
      event.returnValue = 'test';
    }

    window.addEventListener('beforeunload', listener );

    return () => {
      window.removeEventListener('beforeunload', listener );
    };
  }, [is_saved]);

  //#endregion

  //#region [MODIFY]

  //-----------------------------------------------------------------
  function updateRule( update ) {
    //-----------------------------------------------------------------
    const tags_rule   = rule.tags;
    const tags_update = update.tags;
    const tags = { ...tags_rule, ...tags_update };
    
    const updated_rule = { ...rule, ...update };
    updated_rule.tags = tags;
    
    setRule( updated_rule );
  }

  //#endregion

  //#region [MODIFY] === EXPRESSION

  //-----------------------------------------------------------------
  function initExpression( values ) {
    //-----------------------------------------------------------------
    let count = id_expr;
    const array = values.map( data => { return { id: count++, data }; });
    setExpressions( array );

    setIdExpr( count+1 );
  }

  //-----------------------------------------------------------------
  function createExpression( data = {} ) {
    //-----------------------------------------------------------------
    const new_exp = { id: id_expr, data };
    setExpressions( [
      ...expressions,
      new_exp,
    ])

    setIdExpr( id_expr + 1 );
    setIsSaved( false );
  }

  //-----------------------------------------------------------------
  function createExpressions( data = [] ) {
    //-----------------------------------------------------------------
    let count = id_expr;
    const new_exps = data.map( x => { return { id: count++, data: x } } );
    
    setExpressions( [
      ...expressions,
      ...new_exps,
    ])

    setIdExpr( count );
    setIsSaved( false );
  }


  //-----------------------------------------------------------------
  function updateExpression( id, data ) {
    //-----------------------------------------------------------------
    const temp = expressions.map( exp => {
      const is_exp = exp.id === id;
      if( is_exp ) {
        const new_data = { ...exp.data, ...data };
        const new_exp = { id: exp.id, data: new_data };
        return new_exp;
      }

      return exp;
    } );
    
    setExpressions( temp );
    setIsSaved( false );
  }

  //-----------------------------------------------------------------
  function removeExpression( id ) {
    //-----------------------------------------------------------------
    const temp = expressions.filter( exp => exp.id !== id );
    setExpressions( temp );
    setIsSaved( false );
  }

  //-----------------------------------------------------------------
  function moveExpression( a, b, is_above ) {
    //-----------------------------------------------------------------
    const temp = [...expressions];
    const index_a = temp.findIndex( x => x.id === a.id );
    const index_b = temp.findIndex( x => x.id === b.id );

    const   to_above = is_above;
    const from_above = index_a < index_b;
    const to_above_from_above =  to_above &&  from_above;
    const to_above_from_below =  to_above && !from_above;
    const to_below_from_above = !to_above &&  from_above;
    const to_below_from_below = !to_above && !from_above;

    const direction = to_above_from_above ? 0 : to_above_from_below ? 0 : to_below_from_above ? 1 : to_below_from_below ? 1 : 0;

    const item_a = temp.splice( index_a, 1 )?.[0];
    const index_b_new = from_above ? index_b-1 : index_b;
    temp.splice( index_b_new + direction, 0, item_a );

    setExpressions( temp );
    setIsSaved( false );
  }

  //#endregion

  //#region [MODIFY] === PREDICATES

  //-----------------------------------------------------------------
  function initPredicates( values ) {
    //-----------------------------------------------------------------
    let count = id_pred;
    const array = values.map( data => { return { id: count++, data }; });
    setPredicates( array );

    setIdPred( count+1 );
  }

  //-----------------------------------------------------------------
  function createPredicate( data = {} ) {
    //-----------------------------------------------------------------
    const new_exp = { id: id_pred, data };
    
    setPredicates( [
      ...predicates,
      new_exp,
    ])

    setIdPred( id_pred + 1 );
    setIsSaved( false );
  }

  //-----------------------------------------------------------------
  function createPredicates( data = [] ) {
    //-----------------------------------------------------------------
    let count = id_pred;
    const new_exps = data.map( x => { return { id: count++, data: x } } );
    
    setPredicates( [
      ...predicates,
      ...new_exps,
    ])

    setIdPred( count );
    setIsSaved( false );
  }

  //-----------------------------------------------------------------
  function updatePredicate( id, data ) {
    //-----------------------------------------------------------------
    const temp = predicates.map( pred => {
      const is_exp = pred.id === id;
      if( is_exp ) {
        const new_data = { ...pred.data, ...data };
        const new_exp = { id: pred.id, data: new_data };
        return new_exp;
      }

      return pred;
    } );
    
    setPredicates( temp );
    setIsSaved( false );
  }

  //-----------------------------------------------------------------
  function removePredicate( id ) {
    //-----------------------------------------------------------------
    const temp = predicates.filter( exp => exp.id !== id );
    setPredicates( temp );
    setIsSaved( false );
  }

  //-----------------------------------------------------------------
  function movePredicate( a, b, is_above ) {
    //-----------------------------------------------------------------
    const temp = [...predicates];
    const index_a = temp.findIndex( x => x.id === a.id );
    const index_b = temp.findIndex( x => x.id === b.id );

    const   to_above = is_above;
    const from_above = index_a < index_b;
    const to_above_from_above =  to_above &&  from_above;
    const to_above_from_below =  to_above && !from_above;
    const to_below_from_above = !to_above &&  from_above;
    const to_below_from_below = !to_above && !from_above;

    const direction = to_above_from_above ? 0 : to_above_from_below ? 0 : to_below_from_above ? 1 : to_below_from_below ? 1 : 0;

    const item_a = temp.splice( index_a, 1 )?.[0];
    const index_b_new = from_above ? index_b-1 : index_b;
    temp.splice( index_b_new + direction, 0, item_a );

    setPredicates( temp );
    setIsSaved( false );
  }

  //#endregion

  //-----------------------------------------------------------------
  function save( ) {
    //-----------------------------------------------------------------
    setIsSaved( true );
  }

  const values = {
    rule        , updateRule     ,
    expressions , setExpressions ,
    predicates  , setPredicates  ,
    removeExpression, createExpression, createExpressions, updateExpression, moveExpression,
    removePredicate , createPredicate , createPredicates , updatePredicate , movePredicate ,
    fields, documents, tables, records, table_columns, templates,
    save, is_saved,
  };

  return (
    <ExpressionContext.Provider value={ values }>
      {children}
    </ExpressionContext.Provider>
  );
};

export { ExpressionContext, ExpressionProvider };